import { Vector2 } from "./Vector2";
export var Circle;
(function (Circle) {
    function contains(self, pos) {
        return Vector2.lengthSquared(Vector2.sub(pos, self.center)) < (self.radius * self.radius);
    }
    Circle.contains = contains;
})(Circle || (Circle = {}));
